import { render, staticRenderFns } from "./GameLobby.vue?vue&type=template&id=8565cdba"
import script from "./GameLobby.vue?vue&type=script&lang=js"
export * from "./GameLobby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports